import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';

@customElement('langhout-button')
export class LanghoutButton extends LitElement {
  static styles = css`
    #button {
      text-align: center;
      max-width: 100%;
      background-color: var(--primary-color);
      color: var(--text-color-light);
      padding: var(--button-padding, 12px);
      border-radius: 10px;
      font-weight: 900;
      max-height: 28px;
      overflow: hidden;
      line-height: 31px;
      white-space: nowrap;
      text-overflow: hidden;
    }

    :host([reverse]) #button {
      background-color: white;
      color: var(--primary-color);
      border: 1px solid var(--primary-color);
    }

    :host([removeButton]) #button {
      background-color: white;
      color: red;
      border: 1px solid red;
    }
  `;

  @property({ type: String, reflect: true })
  public text = 'Button';

  @property({ type: Boolean, reflect: true })
  public reverse = false;

  @property({ type: Boolean, reflect: true })
  public removeButton = false;

  constructor() {
    super();
  }

  render() {
    return html`<div id="button">${this.text}</div> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'langhout-button': LanghoutButton;
  }
}
